import { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Card, Form, Input, message, Modal, Table, Typography } from "antd";
import { PlusOutlined, ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { api } from "../services/apiClient";

const { Title, Text } = Typography;

export default function SystemYoutubeCredentials() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setItems((await api.get("/api/system/youtube-credentials")) || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load().catch((error) => message.error(error.message));
  }, [load]);

  const create = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      await api.post("/api/system/youtube-credentials", values);
      message.success("Đã thêm credential hệ thống");
      setOpen(false);
      form.resetFields();
      await load();
    } catch (error) {
      if (error.message) message.error(error.message);
    } finally {
      setSaving(false);
    }
  };

  const columns = useMemo(() => [
    { title: "STT", width: 72, align: "center", render: (_, __, index) => index + 1 },
    {
      title: "USER CHỦ",
      width: "22%",
      render: (_, item) => (
        <div>
          <Text strong>{item.username || "-"}</Text>
          {item.email && <><br /><Text type="secondary">{item.email}</Text></>}
        </div>
      ),
    },
    { title: "CLIENT ID", dataIndex: "clientId", width: "35%", render: (value) => <Text copyable>{value}</Text> },
    { title: "CLIENT SECRET", dataIndex: "clientSecret", width: "35%", render: (value) => <Text copyable>{value}</Text> },
  ], []);

  const data = useMemo(() => {
    const keyword = search.trim().toLowerCase();
    if (!keyword) return items;
    return items.filter((item) => [item.username, item.email, item.clientId]
      .filter(Boolean)
      .some((value) => String(value).toLowerCase().includes(keyword)));
  }, [items, search]);

  return (
    <>
      <div className="page-heading">
        <div>
          <Title level={3}>Quản lý Credential</Title>
          <Text type="secondary">Quản lý credential YouTube riêng và credential hệ thống.</Text>
        </div>
      </div>
      <Card className="criclebox">
        <div className="auto-toolbar">
          <Input className="auto-toolbar-search" allowClear prefix={<SearchOutlined />} placeholder="Tìm theo username, email hoặc Client ID" value={search} onChange={(event) => setSearch(event.target.value)} />
          <Button icon={<ReloadOutlined />} onClick={load}>Làm mới</Button>
          <Button className="auto-toolbar-primary" type="primary" icon={<PlusOutlined />} onClick={() => setOpen(true)}>Thêm Credential</Button>
        </div>
        <Table rowKey="id" loading={loading} columns={columns} dataSource={data} tableLayout="fixed" pagination={false} />
      </Card>
      <Modal title="Thêm Credential hệ thống" visible={open} onCancel={() => setOpen(false)} onOk={create} confirmLoading={saving} okText="Lưu">
        <Form form={form} layout="vertical">
          <Form.Item name="clientId" label="Client ID" rules={[{ required: true, message: "Nhập Client ID" }]}>
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item name="clientSecret" label="Client Secret" rules={[{ required: true, message: "Nhập Client Secret" }]}>
            <Input.TextArea rows={3} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
